export default {
  getArticle: state => state.article
};
